import React from 'react';

const mandates = [
  {
    num: '01',
    phase: 'Sourcing',
    title: 'AI Thesis',
    subtitle: 'High-Conviction Sector Origination',
    desc: 'Map where AI architecture shifts profit pools before market consensus forms. Eliminates the conviction lag on new deep-tech sectors.',
    color: 'bg-red-50 text-red-600',
  },
  {
    num: '02',
    phase: 'Diligence',
    title: 'AI Moat',
    subtitle: '48h Technical & Commercial DD',
    desc: 'Separates defensible proprietary IP from commodity wrappers. Stress-tests inference margins and foundation model risk.',
    color: 'bg-emerald-50 text-emerald-600',
  },
  {
    num: '03',
    phase: 'Value Creation',
    title: 'Topline Alpha',
    subtitle: 'Agentic Portfolio Re-Platforming',
    desc: 'Injects agentic capabilities into portfolio assets to unlock enterprise expansion, pricing power, and new product lines.',
    color: 'bg-amber-50 text-amber-600',
  },
  {
    num: '04',
    phase: 'Exit',
    title: 'Strategic Exit',
    subtitle: 'Multiple Expansion Architecture',
    desc: 'Reverse-engineers capability gaps of global consolidators to package certified sovereign AI assets and maximize multiples.',
    color: 'bg-purple-50 text-purple-600',
  },
];

export const MandatesSection = () => {
  return (
    <section className="bg-white py-24 px-6 md:px-10 border-t border-slate-100">
      <div>
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16 items-start">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#F58220] mb-4 font-mono">
              Deal Execution Mandates
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-[#0F172A] tracking-tight leading-tight">
              AI for High-Stakes Transactions
            </h2>
          </div>
          <div className="lg:pt-8">
            <p className="text-base text-slate-500 leading-relaxed">
              In addition to licensing Deal OS, firms engage Frontier directly on
              live, confidential transactions to underwrite real AI moats and
              accelerate value.
            </p>
          </div>
        </div>

        {/* Mandate cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {mandates.map((mandate) => (
            <div
              key={mandate.num}
              className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-lg transition-shadow flex flex-col"
            >
              <div className="flex items-center justify-between mb-6">
                <span className={`text-[11px] font-bold rounded-full w-8 h-8 flex items-center justify-center ${mandate.color}`}>
                  {mandate.num}
                </span>
                <span className="text-[9px] font-bold uppercase tracking-[0.2em] text-slate-400 font-mono">
                  {mandate.phase}
                </span>
              </div>
              <h3 className="text-xl font-bold text-[#0F172A] mb-1">{mandate.title}</h3>
              <p className="text-[11px] text-slate-400 font-mono mb-4">{mandate.subtitle}</p>
              <p className="text-sm text-slate-500 leading-relaxed flex-1">{mandate.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
